(() => {
  const observed = new WeakSet();
  const purposes = { first_name: 'given-name', last_name: 'family-name', email: 'email' };
  function connect(host) {
    if (observed.has(host)) return;
    const root = host.shadowRoot;
    if (!root) return;
    observed.add(host);
    function repair() {
      root.querySelectorAll('label[for]').forEach(label => {
        const target = label.htmlFor;
        if (root.getElementById(target)) return;
        const field = Array.from(root.querySelectorAll('input[name], textarea[name], select[name]'))
          .find(element => element.name === target && !element.id);
        if (field) field.id = target;
      });
      Object.entries(purposes).forEach(([id, value]) => {
        const field = root.getElementById(id);
        if (field && (!field.autocomplete || field.autocomplete === 'off')) field.autocomplete = value;
      });
    }
    repair();
    new MutationObserver(repair).observe(root, { childList: true, subtree: true });
  }
  function discover() {
    document.querySelectorAll('shopify-forms-embed').forEach(connect);
  }
  discover();
  new MutationObserver(discover).observe(document.body, { childList: true, subtree: true });
  let attempts = 0;
  const timer = setInterval(() => {
    discover();
    if (++attempts >= 40) clearInterval(timer);
  }, 250);
})();
